import { AD_UNIT_PAGES } from './types';

export const EXT_PARTNER_AD_SCRIPT_URL =
    '//js-sec.indexww.com/ht/p/185636-228001238555025.js';

export const DFP_GPT_AD_SCRIPT_URL =
    'https://securepubads.g.doubleclick.net/tag/js/gpt.js';

export const TAILORED_ADVERTISING_ID = 3;

export const LAZY_LOAD_OPTS = {
    fetchMarginPercent: 400 /* Fetch slots within 4 viewports */,
    renderMarginPercent: 200 /* Render slots within 2 viewports */,
    mobileScaling: 2.0 /* Double the above values on mobile, where viewports are smaller and users tend to scroll faster */
};

export const REPORT_AD_URL =
    'https://customer-ads.prod.zoopla.co.uk/ads/report_advert';

export const DFP_TARGETING_DEFAULTS = {
    max_bedrooms: 'all',
    min_bedrooms: 'all',
    max_price: 'all',
    min_price: 'all',
    property_type: 'all',
    beds_max: 'all',
    beds_min: 'all',
    price_max: 'all',
    price_min: 'all'
};

export const PAGE_MAPPING = {
    '/for-sale': AD_UNIT_PAGES.FOR_SALE,
    '/to-rent': AD_UNIT_PAGES.TO_RENT,
    '/new-homes': AD_UNIT_PAGES.NEW_HOMES
};

export const TEXT_LINK_PAGE_MAPPING = {
    '/for-sale': AD_UNIT_PAGES.FOR_SALE_LSRP,
    '/to-rent': AD_UNIT_PAGES.TO_RENT_LSRP,
    '/new-homes': AD_UNIT_PAGES.NEW_HOMES
};
